import React, { useMemo } from 'react';
import { Typography } from 'Tokens';
import { TruncatableText } from 'Atoms';
import { getMetricRefNumber } from '../../../Metrics.hooks';
import { Row } from '@tanstack/react-table';
import { TableData } from 'Molecules/NestedTable';
import { MetricsTableData } from '../../../MetricAnswers.hooks';
import { useParams } from 'react-router-dom';

export const Reference = ({
  optedOutMetrics,
  row,
  isNotSpecialRow,
  isNarrative,
}: {
  optedOutMetrics?: string[];
  row: Row<TableData<MetricsTableData>>;
  isNotSpecialRow: (row: Row<TableData<MetricsTableData>>) => boolean;
  isNarrative?: boolean;
}) => {
  const { framework } = useParams();
  const hasOptedOut = useMemo(
    () => optedOutMetrics?.includes(row.original.metric.reference),
    [optedOutMetrics, row]
  );

  const metricRefNumber = useMemo(() => getMetricRefNumber(row.original.metric), [row]);
  const metricFrameworkRef = row?.original?.metric?.requirement?.frameworkRef;

  return row.original.isAdditionalInfo ? (
    <Typography variant="body">_</Typography>
  ) : (
    isNotSpecialRow(row) && (
      <TruncatableText
        text={
          isNarrative && metricFrameworkRef !== framework
            ? `${metricFrameworkRef} ${metricRefNumber}`
            : metricRefNumber
        }
        color={hasOptedOut ? 'text.hint' : 'text.default'}
      />
    )
  );
};
